document.addEventListener('DOMContentLoaded', function () {
  const switcher = document.querySelector('[data-hcp-switcher]');

  if (!switcher) {
    return;
  }

  const setTypeCookie = (type) => {
    const date = new Date();
    date.setTime(date.getTime() + 30 * 24 * 60 * 60 * 1000);
    document.cookie = `aymes_user_type=${type}; expires=${date.toUTCString()}; path=/`;
  };

  const setCartAttribute = async (userType) => {
    try {
      const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          attributes: {
            user_type: userType,
          },
        }),
      });

      return response.ok;
    } catch {
      return false;
    }
  };

  const setActiveItem = (activeLink) => {
    switcher.querySelectorAll('.hcp-switcher__item').forEach((item) => {
      item.classList.toggle('is-active', item === activeLink);
    });
  };

  const proceedAfterUserTypeSet = (userType, targetUrl, activeLink) => {
    if (window.duelTemplate === 'true') {
      window.location.reload();
      return;
    }

    if (window.patientTemplate === 'true' && userType === 'patient') {
      setActiveItem(activeLink);
      return;
    }

    if (window.patientTemplate === 'false' && userType === 'practitioner') {
      setActiveItem(activeLink);
      return;
    }

    window.location.href = targetUrl || '/';
  };

  const handleContinue = async (e) => {
    e.preventDefault();

    const link = e.currentTarget;
    const userType = link.getAttribute('data-user-type');
    const targetUrl = link.getAttribute('href');

    if (!(await setCartAttribute(userType))) {
      console.error('Error setting cart attribute');
      return;
    }

    setTypeCookie(userType);
    proceedAfterUserTypeSet(userType, targetUrl, link);
  };

  switcher.querySelectorAll('.hcp-switcher__item').forEach((link) => {
    link.addEventListener('click', handleContinue);
  });
});
